import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, TemplateRef } from '@angular/core';

@Component({
  selector: 'abc-confirm-modal',
  imports: [CommonModule],
  templateUrl: 'confirm-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModal {
  modalId = input.required<string>();
  modalTitle = input<string>(
    $localize`:modal title|Default title text for confirmation modals indicating a general action@@modalDefaultTitle:Confirm Action`
  );
  bodyText = input<string>(
    $localize`:modal body|Default body text for confirmation modals prompting user confirmation for the action@@modalDefaultBodyText:Are you sure you want to perform this action`
  );
  bodyTpl = input<TemplateRef<unknown> | null>(null);
  largeModal = input<boolean>(false);
  confirmDisabled = input<boolean>(false);
  confirmClicked = output<void>();

  confirmAction() {
    this.confirmClicked.emit();
  }
}
